import { Instagram, Linkedin, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/constants";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-charcoal-deep border-t border-white/10 text-white/70 py-16 lg:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16">
          <div className="md:col-span-5">
            <img
              src="/logos/logo-full-white.png"
              alt="DEM BAT — Entreprise familiale genevoise"
              className="h-24 w-auto"
            />
            <p className="mt-6 text-white/60 text-sm leading-relaxed font-light max-w-sm">
              Entreprise familiale genevoise de rénovation. Plâtrerie, peinture, isolation,
              stucs, moulures et façades. Depuis plus de 20 ans.
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="text-bronze text-[10px] uppercase tracking-widest mb-5">Contact</div>
            <ul className="space-y-4 text-sm font-light">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-bronze flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>{COMPANY.address}<br />1212 Grand-Lancy · {COMPANY.city}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-bronze flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <a href={`tel:${COMPANY.phoneRaw}`} data-testid="footer-phone" className="hover:text-bronze transition-colors">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-bronze flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="hover:text-bronze transition-colors">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-bronze text-[10px] uppercase tracking-widest mb-5">Suivez-nous</div>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/dembat.ch/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram DEM BAT" className="w-10 h-10 border border-white/15 hover:border-bronze hover:text-bronze flex items-center justify-center transition-colors">
                <Instagram className="w-4 h-4" strokeWidth={1.5} />
              </a>
              <a href="https://www.linkedin.com/company/dembat-ch/posts/?feedView=all" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" aria-label="LinkedIn DEM BAT" className="w-10 h-10 border border-white/15 hover:border-bronze hover:text-bronze flex items-center justify-center transition-colors">
                <Linkedin className="w-4 h-4" strokeWidth={1.5} />
              </a>
            </div>
            <div className="text-bronze text-[10px] uppercase tracking-widest mt-10 mb-5">Carrières</div>
            <Link
              to="/candidatures"
              data-testid="footer-candidatures-link"
              className="text-sm font-light text-white/60 hover:text-bronze transition-colors"
            >
              Vous cherchez un emploi ? Candidatures ici
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-white/40 text-xs">
          <span>© 2026 DEM BAT — Entreprise familiale genevoise</span>
          <span className="uppercase tracking-widest">Design · Excellence · Maîtrise</span>
        </div>
      </div>
    </footer>
  );
};
